<template>
  <nav>
    <!-- Brand -->
    <Brand class="text-left pl-3" />

    <!-- Search -->
    <Search
      class="w-100 pl-3"
      style="flex-grow: 1; flex-shrink: 1; flex-basis: 0%;"
    />

    <!-- Actions -->
    <div class="text-right pr-3">
      <el-popover
        :value="active === 'applications'"
        placement="bottom-end"
        width="400"
        trigger="click"
        style="margin-left: 10px;"
        @after-enter="active = 'applications'"
        @hide="active = null"
      >
        <el-button
          slot="reference"
          type="primary"
          circle
          :class="{ 'is-active': active === 'applications' }"
        >
          <FontAwesomeIcon
            :icon="['fas', 'th']"
            fixed-width
          />
        </el-button>

        <Applications />
      </el-popover>

      <el-button
        type="primary"
        circle
        class="hidden-md-and-up"
      >
        <FontAwesomeIcon
          :icon="['fas', 'search']"
          fixed-width
        />
      </el-button>

      <el-popover
        placement="bottom-end"
        width="400"
        trigger="click"
        style="margin-left: 10px;"
        @after-enter="active = 'notifications'"
        @hide="active = null"
      >
        <el-button
          slot="reference"
          type="primary"
          circle
          :class="{ 'is-active': active === 'notifications' }"
        >
          <FontAwesomeIcon
            :icon="['fas', 'layer-group']"
            fixed-width
          />
        </el-button>

        <NotificationCentre />
      </el-popover>

      <el-badge
        class="item"
        :value="activeIncidents"
        :hidden="activeIncidents < 1"
      >
        <el-popover
          placement="bottom-end"
          width="400"
          trigger="click"
          style="margin-left: 10px;"
          @after-enter="active = 'help'"
          @hide="active = null"
        >
          <el-button
            slot="reference"
            type="primary"
            circle
            :class="{ 'is-active': active === 'help' }"
          >
            <FontAwesomeIcon
              :icon="['fas', 'exclamation']"
              fixed-width
            />
          </el-button>

          <Help @active-incidents="setActiveIncidents" />
        </el-popover>
      </el-badge>

      <el-popover
        placement="bottom-end"
        width="400"
        trigger="click"
        style="margin-left: 10px;"
        @after-enter="active = 'user'"
        @hide="active = null"
      >
        <el-button
          slot="reference"
          type="primary"
          circle
          :class="{ 'is-active': active === 'user' }"
        >
          <FontAwesomeIcon
            :icon="['fas', 'chevron-down']"
            fixed-width
          />
        </el-button>

        <User />
      </el-popover>
    </div>
  </nav>
</template>

<script>
import Brand from '@/components/Navigation/Topbar/Brand'
import Search from '@/components/Navigation/Topbar/Search'
import Applications from '@/components/Navigation/Topbar/Applications'
import NotificationCentre from '@/components/Navigation/Topbar/NotificationCentre'
import Help from '@/components/Navigation/Topbar/Help'
import User from '@/components/Navigation/Topbar/User'
import { mapGetters } from 'vuex'

export default {
  components: {
    Brand,
    Search,
    Applications,
    NotificationCentre,
    Help,
    User
  },
  data () {
    return {
      active: null,
      activeIncidents: 0
    }
  },
  computed: {
    ...mapGetters({
      headerColour: 'configuration/layout/headerColour'
    })
  },
  watch: {
    '$route' () {
      this.active = null
    }
  },
  created () {
    if (this.headerColour) {
      document.documentElement.style.setProperty(
        '--topbar-background-color',
        this.headerColour
      )
    }
  },
  methods: {
    setActiveIncidents (count) {
      this.activeIncidents = count
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'variables';

  nav:first-of-type {
    display: flex;
    align-items: center;
    width: 100vw;
    height: $topbar-height;
    background-color: $topbar-background-color;
  }
</style>
